import React from 'react'
import MainBanner from '../Generator/MainBanner';
import FoldersUploader from '../Generator/FoldersUploader';
import Footer from '../Common/Footer';
 
class NftGenerator extends React.Component {
    render(){
        return (
            <React.Fragment>
                <MainBanner />
                <FoldersUploader />
                <Footer />
            </React.Fragment>
        );
    }
}
 
export default NftGenerator;